// extracted by mini-css-extract-plugin
export default {"form":"AccountForm_form__U5ZY8","submit":"AccountForm_submit__DgQI-","selector":"AccountForm_selector__LB-oA","preloader":"AccountForm_preloader__-cM-B"};